module.exports = __webpack_public_path__ + "img/reminder_timesheet_emt.faa3b605.png";